import React, { Component, createRef } from 'react';
import _ from 'lodash';
import Select from '../common/Select';
import StreamTDSScriptValues from './StreamTDSScriptValues';
import { Col, Row } from 'reactstrap';
import Icon from '../Icon/Icon';
import { FormGroup } from 'reactstrap';
import {hasErrorInOption, getErrorMessage} from './formErrorHelper';

class StreamTDSScriptOption extends Component {
  constructor(props) {
    super(props);
    this._alertRefs = {
      scriptsOptionsTypeErrors: createRef(),
    };
  }
  getOptTypes = () => {
    const {settingsTDS} = this.props;
    return Object.keys(settingsTDS).map(s => ({
      value: settingsTDS[s].type,
      label: settingsTDS[s].name,
      multiple: _.includes(settingsTDS[s].sub_types, 'multiple')
    }));
  }
  getSettings = () => {
    const {
      scriptOption,
      settingsTDS,
    } = this.props;
    const settings = _.find(settingsTDS, s => s.type === scriptOption.t);
    return settings;
  }
  isMulti = optTypes => {
    const {scriptOption} = this.props;
    return _.get(_.find(optTypes, {value: scriptOption.t}), 'multiple');
  }
  optTypeHasError = () => {
    const {errors, optKey, scrKey} = this.props;
    return hasErrorInOption({
      errors,
      errorPath: 'scriptsOptionsTypeErrors',
      optKey,
      scrKey,
    });
  }
  componentDidMount() {
    const {saveRef, scrKey, optKey} = this.props;
    saveRef(true, 'scriptsOptionsTypeErrors', this._alertRefs.scriptsOptionsTypeErrors, scrKey, optKey);
  }
  render() {
    const {
      errors,
      scrKey,
      onSelectScriptOptionType,
      optKey,
      scriptOption,
      deleteScriptOption,
      onChangeScriptOptionValue,
      settingsTDS,
      allSettingsTDS,
      scriptOptionsLength,
      saveRef,
    } = this.props;
    const optTypes = this.getOptTypes();
    const optTypeHasError = this.optTypeHasError();
    return (
      <FormGroup className='stream-tds-script-option'>
        <Row>
          <Col lg="6" xs='10'>
            <div
              ref={this._alertRefs.scriptsOptionsTypeErrors}
              id={`scriptsOptionsTypeErrors${scrKey}_${optKey}`}
            >
              <Select
                className={
                  `stream-tds-script-option-type ${optTypeHasError ? 'has-error' : ''}`
                }
                clearable={false}
                value={scriptOption.t}
                onChange={({value}) => onSelectScriptOptionType(scrKey, optKey, value)}
                options={optTypes}
              />
              {optTypeHasError && <small className="form-text">{getErrorMessage('scriptsOptionsTypeErrors')}</small>}
            </div>
          </Col>
          <Col lg="5" xs='10'>
            {
              optTypes.length > 0 &&
              scriptOption.t &&
                <StreamTDSScriptValues
                  settings={this.getSettings()}
                  settingsTDS={settingsTDS}
                  allSettingsTDS={allSettingsTDS}
                  type={scriptOption.t}
                  value={scriptOption.s}
                  multiple={this.isMulti(optTypes)}
                  scrKey={scrKey}
                  optKey={optKey}
                  errors={errors}
                  errorPath='scriptsOptionsValueErrors'
                  onChangeScriptOptionValue={
                    value => onChangeScriptOptionValue(scrKey, optKey, value)
                  }
                  onChangeScriptOptionValue={
                    value => onChangeScriptOptionValue(scrKey, optKey, value)
                  }
                  saveRef={saveRef}
                />
            }
          </Col>
          <Col xs="1" className='icon-trash-wrapper'>
            {scriptOptionsLength > 1 ?
              <Icon
                type="trash"
                onClick={() => deleteScriptOption(scrKey, optKey)}
              />
              :
              null
            }
          </Col>
        </Row>
      </FormGroup>
    );
  }
}

export default StreamTDSScriptOption;